module.exports = __webpack_public_path__ + "img/my_active.53c4ee35.svg";